// src/components/padrekko/qc/CustomerSendBackModal.jsx
//
// Phase 2 — customer "send back to operator" modal. Distinct from
// SendBackModal (the generic reverse-stage path that returns a case to the
// PREVIOUS stage / DH). This one calls the dedicated POST /cases/:id/send-back
// endpoint, which returns the case to the OPERATOR for more work with NO
// all-pads-terminal gate and WITHOUT incrementing operator_pass_count.
//
// Visible only to the customer_analyst at customer_review with
// operator_pass_count > 0 (gated by CaseBanner). Reason is REQUIRED — the
// customer is compelling additional operator work and must document why.
//
// Thin wrapper over the shared MandatoryReasonModal (reason + submit shell).

import { RotateCcw } from "lucide-react";
import { useQcStore } from "../../../stores/useQcStore";
import MandatoryReasonModal from "./MandatoryReasonModal";

export default function CustomerSendBackModal({ isOpen, onClose }) {
  const caseInfo           = useQcStore((s) => s.caseInfo);
  const sendBackToOperator = useQcStore((s) => s.sendBackToOperator);

  if (!isOpen || !caseInfo) return null;

  return (
    <MandatoryReasonModal
      isOpen={isOpen}
      onClose={onClose}
      title="Send back to operator?"
      icon={<RotateCcw size={12} />}
      description="The operator will receive this case for additional work. Please describe what needs to be addressed."
      label="Reason for sending back"
      placeholder="Explain what the operator needs to revise or add."
      submitLabel="Send back"
      submittingLabel="Sending…"
      onSubmit={(reason) => sendBackToOperator({ reason })}
    />
  );
}
